const countryNames = require('i18n-iso-countries')
const languages = require('./languages')

// Country names in every served language, for the coverage pages (built in gatsby-node.js) and the
// "Myphoner in {{country}}" link (rendered in the browser; gatsby-browser.js loads this file for that).
const locales = {
  da: require('i18n-iso-countries/langs/da.json'),
  de: require('i18n-iso-countries/langs/de.json'),
  en: require('i18n-iso-countries/langs/en.json'),
  es: require('i18n-iso-countries/langs/es.json'),
  fr: require('i18n-iso-countries/langs/fr.json'),
  it: require('i18n-iso-countries/langs/it.json'),
  pt: require('i18n-iso-countries/langs/pt.json'),
}
for (const language of languages) {
  if (!locales[language]) throw new Error(`coverageCountries.js has no country names for "${language}"`)
  countryNames.registerLocale(locales[language])
}

// The entries of api.myphoner.com/countries.json that are real countries. The API also lists rate zones
// such as "Special" and "No country" with made-up ISO codes; they have no name in any language and would all
// get the same page at /coverage/undefined/.
const coverageCountries = (results) =>
  results
    .filter((country) => country.name.trim() !== 'AK-Dev' && countryNames.getName(country.iso3166.toLowerCase(), 'en'))
    .map((country) => ({ ...country, code: country.iso3166.toLowerCase(), value: country.id, label: country.name }))

module.exports = { countryNames, coverageCountries }
